import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function Breakfast({ brand, isActive, width }) {
    const topBagelColor = brand === MISFITS_THEME_DOMAIN ? '#F2D89B' : '#F8E1A4';
    const bottomBagelColor = brand === MISFITS_THEME_DOMAIN ? '#E0A555' : '#F7D46D';
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';
    const inactiveBagelColor = brand === MISFITS_THEME_DOMAIN ? '#E0A555' : '#F8E1A4';

    return isActive ? (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                fill={activeColor}
            />
            <g clipPath="url(#clip0_6162_2381)">
                <path
                    d="M17.8143 2.22998C12.3154 2.22998 7.86206 6.61806 7.86206 12.0365C7.86206 17.4549 12.3154 21.8429 17.8143 21.8429C23.3133 21.8429 27.7666 17.4549 27.7666 12.0365C27.7666 6.61806 23.3133 2.22998 17.8143 2.22998ZM17.8143 14.925C16.1992 14.925 14.8828 13.6371 14.8828 12.0365C14.8828 10.4358 16.1899 9.14787 17.8143 9.14787C19.4388 9.14787 20.7459 10.4358 20.7459 12.0365C20.7459 13.6371 19.4388 14.925 17.8143 14.925Z"
                    fill={topBagelColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M26.4596 8.88122L25.6287 7.59332C25.5447 7.46453 25.4793 7.33574 25.4327 7.18855L24.5737 4.64034C24.3123 3.8584 23.5468 3.35243 22.7159 3.39843L17.6837 3.67441C17.3196 3.69281 16.9555 3.61001 16.6474 3.42603L16.1619 3.15005C15.275 2.64409 14.1453 2.93846 13.6318 3.8032L12.082 6.43421C11.8113 6.88497 11.3632 7.20695 10.8403 7.30814C9.48661 7.56572 8.8891 9.148 9.73868 10.2243L11.0364 11.8526C11.4472 12.3678 11.5499 13.0669 11.2978 13.6741L10.6536 15.2196C10.3922 15.8451 10.5042 16.5627 10.943 17.0778L12.5208 18.9453C12.9316 19.4328 13.5758 19.672 14.2107 19.58L16.7688 19.2029C17.0022 19.1661 17.2449 19.1753 17.4783 19.2305L20.5032 19.9572C21.0447 20.086 21.6142 19.9664 22.0623 19.6352L24.9565 17.4642C25.4233 17.1146 25.6941 16.5719 25.6847 15.9923L25.6567 13.7201C25.6567 13.5177 25.6847 13.3153 25.7501 13.1221L26.6557 10.4175C26.8331 9.89315 26.7584 9.33199 26.4596 8.86283V8.88122ZM17.8144 14.9252C16.1993 14.9252 14.8829 13.6373 14.8829 12.0366C14.8829 10.4359 16.1899 9.148 17.8144 9.148C19.4389 9.148 20.7459 10.4359 20.7459 12.0366C20.7459 13.6373 19.4389 14.9252 17.8144 14.9252Z"
                    fill="white"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M11.4471 8.64209C5.80809 8.64209 1.2334 13.1498 1.2334 18.7061C1.2334 24.2625 5.80809 28.7702 11.4471 28.7702C17.0861 28.7702 21.6608 24.2625 21.6608 18.7061C21.6608 13.1498 17.0861 8.64209 11.4471 8.64209ZM11.4471 21.6683C9.78527 21.6683 8.44087 20.3436 8.44087 18.7061C8.44087 17.0687 9.78527 15.744 11.4471 15.744C13.1089 15.744 14.4533 17.0687 14.4533 18.7061C14.4533 20.3436 13.1089 21.6683 11.4471 21.6683Z"
                    fill={bottomBagelColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M17.9264 15.1001C18.0244 15.1001 18.1038 15.0218 18.1038 14.9253C18.1038 14.8287 18.0244 14.7505 17.9264 14.7505C17.8284 14.7505 17.749 14.8287 17.749 14.9253C17.749 15.0218 17.8284 15.1001 17.9264 15.1001Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M10.2707 14.2812C10.3532 14.2812 10.4201 14.2153 10.4201 14.134C10.4201 14.0527 10.3532 13.9868 10.2707 13.9868C10.1882 13.9868 10.1213 14.0527 10.1213 14.134C10.1213 14.2153 10.1882 14.2812 10.2707 14.2812Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M3.32467 17.4184C3.40717 17.4184 3.47405 17.3525 3.47405 17.2712C3.47405 17.1899 3.40717 17.124 3.32467 17.124C3.24217 17.124 3.17529 17.1899 3.17529 17.2712C3.17529 17.3525 3.24217 17.4184 3.32467 17.4184Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M7.49795 13.1681C7.57529 13.1681 7.63799 13.1063 7.63799 13.0301C7.63799 12.9539 7.57529 12.8921 7.49795 12.8921C7.42061 12.8921 7.35791 12.9539 7.35791 13.0301C7.35791 13.1063 7.42061 13.1681 7.49795 13.1681Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M5.90151 15.7441C5.99947 15.7441 6.07889 15.6659 6.07889 15.5693C6.07889 15.4728 5.99947 15.3945 5.90151 15.3945C5.80354 15.3945 5.72412 15.4728 5.72412 15.5693C5.72412 15.6659 5.80354 15.7441 5.90151 15.7441Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M5.90138 18.0436C6.00966 18.0436 6.09744 17.9571 6.09744 17.8504C6.09744 17.7437 6.00966 17.6572 5.90138 17.6572C5.7931 17.6572 5.70532 17.7437 5.70532 17.8504C5.70532 17.9571 5.7931 18.0436 5.90138 18.0436Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M13.557 23.352C13.655 23.352 13.7344 23.2738 13.7344 23.1772C13.7344 23.0807 13.655 23.0024 13.557 23.0024C13.4591 23.0024 13.3796 23.0807 13.3796 23.1772C13.3796 23.2738 13.4591 23.352 13.557 23.352Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M17.6369 23.3978C17.74 23.3978 17.8236 23.3154 17.8236 23.2138C17.8236 23.1122 17.74 23.0298 17.6369 23.0298C17.5338 23.0298 17.4502 23.1122 17.4502 23.2138C17.4502 23.3154 17.5338 23.3978 17.6369 23.3978Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M16.6846 21.1993C16.7775 21.1993 16.8527 21.1252 16.8527 21.0338C16.8527 20.9423 16.7775 20.8682 16.6846 20.8682C16.5918 20.8682 16.5166 20.9423 16.5166 21.0338C16.5166 21.1252 16.5918 21.1993 16.6846 21.1993Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M19.4575 18.4578C19.5606 18.4578 19.6442 18.3754 19.6442 18.2738C19.6442 18.1722 19.5606 18.0898 19.4575 18.0898C19.3544 18.0898 19.2708 18.1722 19.2708 18.2738C19.2708 18.3754 19.3544 18.4578 19.4575 18.4578Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M15.1908 16.4337C15.2836 16.4337 15.3588 16.3596 15.3588 16.2681C15.3588 16.1767 15.2836 16.1025 15.1908 16.1025C15.0979 16.1025 15.0227 16.1767 15.0227 16.2681C15.0227 16.3596 15.0979 16.4337 15.1908 16.4337Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M7.78731 24.1614C7.89043 24.1614 7.97403 24.0791 7.97403 23.9774C7.97403 23.8758 7.89043 23.7935 7.78731 23.7935C7.68418 23.7935 7.60059 23.8758 7.60059 23.9774C7.60059 24.0791 7.68418 24.1614 7.78731 24.1614Z"
                    fill="#2D2D2D"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_6162_2381">
                    <rect width="27" height="27" fill="white" transform="translate(1 2)" />
                </clipPath>
            </defs>
        </svg>
    ) : (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.94 4C8.9 4 4 8.9 4 14.94C4 20.98 8.9 25.88 14.94 25.88C20.98 25.88 25.88 20.98 25.88 14.94C25.88 8.9 20.99 4 14.94 4ZM14.94 18.16C13.16 18.16 11.72 16.72 11.72 14.94C11.72 13.16 13.16 11.72 14.94 11.72C16.72 11.72 18.16 13.16 18.16 14.94C18.16 16.72 16.72 18.16 14.94 18.16Z"
                fill={inactiveBagelColor}
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M21.8799 11.0201C21.9849 11.0201 22.0699 10.9351 22.0699 10.8301C22.0699 10.7252 21.9849 10.6401 21.8799 10.6401C21.775 10.6401 21.6899 10.7252 21.6899 10.8301C21.6899 10.9351 21.775 11.0201 21.8799 11.0201Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M13.68 10.1301C13.7684 10.1301 13.84 10.0584 13.84 9.97006C13.84 9.88169 13.7684 9.81006 13.68 9.81006C13.5917 9.81006 13.52 9.88169 13.52 9.97006C13.52 10.0584 13.5917 10.1301 13.68 10.1301Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M6.24008 13.5402C6.32844 13.5402 6.40008 13.4686 6.40008 13.3802C6.40008 13.2918 6.32844 13.2202 6.24008 13.2202C6.15171 13.2202 6.08008 13.2918 6.08008 13.3802C6.08008 13.4686 6.15171 13.5402 6.24008 13.5402Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M10.7101 8.92012C10.7929 8.92012 10.8601 8.85296 10.8601 8.77012C10.8601 8.68727 10.7929 8.62012 10.7101 8.62012C10.6272 8.62012 10.5601 8.68727 10.5601 8.77012C10.5601 8.85296 10.6272 8.92012 10.7101 8.92012Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M9.00006 11.7198C9.10499 11.7198 9.19006 11.6348 9.19006 11.5298C9.19006 11.4249 9.10499 11.3398 9.00006 11.3398C8.89512 11.3398 8.81006 11.4249 8.81006 11.5298C8.81006 11.6348 8.89512 11.7198 9.00006 11.7198Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M9.00004 14.2198C9.11602 14.2198 9.21004 14.1258 9.21004 14.0098C9.21004 13.8938 9.11602 13.7998 9.00004 13.7998C8.88406 13.7998 8.79004 13.8938 8.79004 14.0098C8.79004 14.1258 8.88406 14.2198 9.00004 14.2198Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M17.2 19.9899C17.3049 19.9899 17.39 19.9048 17.39 19.7999C17.39 19.6949 17.3049 19.6099 17.2 19.6099C17.0951 19.6099 17.01 19.6949 17.01 19.7999C17.01 19.9048 17.0951 19.9899 17.2 19.9899Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M21.5701 20.0401C21.6806 20.0401 21.7701 19.9506 21.7701 19.8401C21.7701 19.7297 21.6806 19.6401 21.5701 19.6401C21.4597 19.6401 21.3701 19.7297 21.3701 19.8401C21.3701 19.9506 21.4597 20.0401 21.5701 20.0401Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M20.5501 17.6598C20.6495 17.6598 20.7301 17.5792 20.7301 17.4798C20.7301 17.3804 20.6495 17.2998 20.5501 17.2998C20.4507 17.2998 20.3701 17.3804 20.3701 17.4798C20.3701 17.5792 20.4507 17.6598 20.5501 17.6598Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M23.5201 14.67C23.6305 14.67 23.7201 14.5805 23.7201 14.47C23.7201 14.3596 23.6305 14.27 23.5201 14.27C23.4096 14.27 23.3201 14.3596 23.3201 14.47C23.3201 14.5805 23.4096 14.67 23.5201 14.67Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M18.95 12.4699C19.0494 12.4699 19.13 12.3893 19.13 12.2899C19.13 12.1905 19.0494 12.1099 18.95 12.1099C18.8506 12.1099 18.77 12.1905 18.77 12.2899C18.77 12.3893 18.8506 12.4699 18.95 12.4699Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M11.0201 20.88C11.1305 20.88 11.2201 20.7904 11.2201 20.68C11.2201 20.5695 11.1305 20.48 11.0201 20.48C10.9096 20.48 10.8201 20.5695 10.8201 20.68C10.8201 20.7904 10.9096 20.88 11.0201 20.88Z"
                fill="#2D2D2D"
                stroke="#231F20"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

Breakfast.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Breakfast.defaultProps = {
    isActive: false,
    width: 30,
};
